'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteInput = function (_Component) {
  (0, _inherits3.default)(DeleteInput, _Component);

  function DeleteInput() {
    (0, _classCallCheck3.default)(this, DeleteInput);
    return (0, _possibleConstructorReturn3.default)(this, (DeleteInput.__proto__ || (0, _getPrototypeOf2.default)(DeleteInput)).call(this));
  }

  (0, _createClass3.default)(DeleteInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          deleteInput = _props.deleteInput;

      return _react2.default.createElement(
        _components.EnterpriseButton,
        {
          size: 'MEDIUM',
          type: 'DANGER',
          onClick: function onClick() {
            deleteInput(id);
          }
        },
        'Delete'
      );
    }
  }]);
  return DeleteInput;
}(_react.Component);

exports.default = DeleteInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteInput/DeleteInput.jsx
// module id = 1452
// module chunks = 0